import { render, staticRenderFns } from "./QueuesNav.vue?vue&type=template&id=3e9f00f0&"
import script from "./QueuesNav.vue?vue&type=script&lang=js&"
export * from "./QueuesNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports